import type { PublicPadFile } from "../shared";
import { copyTextToClipboard } from "./clipboard";
import { isTextLike } from "./pad";

export async function copyFile(file: PublicPadFile) {
  const response = await fetch(file.downloadUrl);
  if (!response.ok) {
    throw new Error("Could not copy file");
  }

  const blob = await response.blob();
  const clipboardWithItems = navigator.clipboard as Clipboard & {
    write?: (items: ClipboardItem[]) => Promise<void>;
  };

  if (file.type.startsWith("image/") && clipboardWithItems.write && "ClipboardItem" in window) {
    await clipboardWithItems.write([new ClipboardItem({ [blob.type || file.type]: blob })]);
    return "Image copied";
  }

  if (isTextLike(file)) {
    const copied = await copyTextToClipboard(await blob.text());
    if (!copied) throw new Error("Could not copy file text");
    return "File text copied";
  }

  const copied = await copyTextToClipboard(new URL(file.downloadUrl, window.location.href).href);
  if (!copied) throw new Error("Could not copy file link");
  return "File link copied";
}
